import React, {useState, useEffect} from 'react'
import { Container, Button, Card, Table, InputGroup, FloatingLabel, Form } from 'react-bootstrap';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import axios from 'axios';
import API from '../utils/api';
import { toast } from "react-toastify";
import Pagination from '../utils/Pagination'
import { ArrowClockwise, Trash, PlusLg, Search  } from 'react-bootstrap-icons';
import Error from '../Error'

const Clientes = () => {

  var url = API.urlAPI
  const urlCliente = url + "clientes"

  const [clienteSeleccionado, setclienteSeleccionado] = useState({
    Nombre: '', 
    Apellido: '',
    DNI: '',
    Domicilio: '',
    Telefono: '',
    email: '',
    Observaciones: ''   // ✅ NUEVO
  })

  const [modalInsertar, setModalInsertar]=useState(false);
  const [modalEditar, setModalEditar]=useState(false);
  const [modalEliminar, setModalEliminar]=useState(false);
  const [search, setSearch] = useState("")
  const [error , setError] = useState(false)
  const [clientes, setClientes] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(25);

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = clientes.slice(indexOfFirstRecord, indexOfLastRecord);
  const nPages = Math.ceil(clientes.length / recordsPerPage)

  const getClientes = () => {
    fetch(urlCliente)
      .then((r) => r.json())
      .then((clientes) => setClientes(clientes))
  }

  useEffect(() => {
    getClientes();
  }, [])

  const abrirCerrarModalInsertar=()=>{
    setError(false)
    setModalInsertar(!modalInsertar);
  }

  const abrirCerrarModalEditar=()=>{
    setError(false)
    setModalEditar(!modalEditar);
  }

  const abrirCerrarModalEliminar=()=>{
    setError(false)
    setModalEliminar(!modalEliminar);
  }

  const handleChange = e => {
    const { name, value } = e.target;
    setclienteSeleccionado({
      ...clienteSeleccionado,
      [name]: value
    });
  }

  // ✅ POST
  const NuevoCliente = () => {
    const{Nombre, Apellido, DNI, Domicilio } = clienteSeleccionado

    if ( [Nombre, Apellido, DNI, Domicilio].includes('')){
      setError(true)
      return;
    }

    setError(false)

    axios.post(urlCliente, clienteSeleccionado)
      .then(() => {
        toast.success("Cliente Creado");
        abrirCerrarModalInsertar();
        getClientes();
      })
      .catch(err => console.log(err))
  }

  // ✅ PUT
  const EditarCliente = () => {

    const{Nombre, Apellido, DNI, Domicilio } = clienteSeleccionado

    if ( [Nombre, Apellido, DNI, Domicilio].includes('')){
      setError(true)
      return;
    }

    setError(false)

    const urlUpdate = urlCliente + "/" + clienteSeleccionado.IdCliente

    axios.put(urlUpdate, clienteSeleccionado)
      .then(() => {
        abrirCerrarModalEditar()
        toast.info("Cliente Actualizado");
        getClientes();

        setclienteSeleccionado({
          Nombre: '', 
          Apellido: '',
          DNI: '',
          Domicilio: '',
          Telefono: '',
          email: '',
          Observaciones: ''   // ✅ RESET
        })
      })
      .catch(err => console.log(err))
  }

  // ✅ DELETE
  const EliminarCliente = async () => {
    await axios.delete(urlCliente+"/"+ clienteSeleccionado.IdCliente)
      .then(()=>{
        abrirCerrarModalEliminar();
        toast.error("Cliente Eliminado");
        getClientes();
      }).catch(error=>{
        console.log(error);
      })
  }

  const seleccionarCliente=(item, caso)=>{
    setclienteSeleccionado(item);
    (caso==="Editar")?
      abrirCerrarModalEditar():
      abrirCerrarModalEliminar();
  }

  const searcher = (e) => {
    setSearch(e.target.value)
  }

  const results = !search
    ? currentRecords
    : clientes.filter((dato) =>
        dato.DNI.toString().includes(search) ||
        dato.Nombre.toLowerCase().includes(search.toLowerCase()) ||
        dato.Apellido.toLowerCase().includes(search.toLowerCase())
      )

  return (
    <>
      <Container>
        <Card>
          <Card.Header style={{ background: "#005187", color:"white"}}>
            <h3>Administración Clientes</h3>
          </Card.Header>

          <Card.Body>

            <Button variant="success"
              style={{ borderRadius: '50%', height: '65px', width: '65px' }}
              onClick={abrirCerrarModalInsertar}>
              <PlusLg size={"lg"}/>
            </Button>

            <br/><br/>

            <InputGroup>
              <InputGroup.Text><Search/></InputGroup.Text>
              <FloatingLabel label="Busqueda Nombre y Apellido">
                <Form.Control value={search} onChange={searcher} type="text" />
              </FloatingLabel>
            </InputGroup>

            <br/>

            <Table responsive>
              <thead>
                <tr style={{ background: "#5589c4", color: "white"}}>
                  <th>Id</th>
                  <th>Nombre</th>
                  <th>Apellido</th>
                  <th>DNI</th>
                  <th>Domicilio</th>
                  <th>Telefono</th>
                  <th>Email</th>
                  <th>Observaciones</th> {/* ✅ NUEVO */}
                  <th>Acción</th>
                </tr>
              </thead>

              <tbody>
                {results.map((item) =>
                  <tr key={item.IdCliente}>
                    <td>{item.IdCliente}</td>
                    <td>{item.Nombre}</td>
                    <td>{item.Apellido}</td>
                    <td>{item.DNI}</td>
                    <td>{item.Domicilio}</td>
                    <td>{item.Telefono}</td>
                    <td>{item.email}</td>
                    <td style={{maxWidth: 200, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                      {item.Observaciones}
                    </td>
                    <td>
                      <Button size='sm' variant='warning' onClick={()=>seleccionarCliente(item, "Editar")}>
                        <ArrowClockwise />
                      </Button>
                      {" | "}
                      <Button size='sm' variant='danger' onClick={()=>seleccionarCliente(item, "Eliminar")}>
                        <Trash />
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

            <Pagination
              nPages={nPages}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />

          </Card.Body>
        </Card>
      </Container>

      {/* INSERTAR */}
      <Modal isOpen={modalInsertar}>
        <ModalHeader>Nuevo Cliente</ModalHeader>
        <ModalBody>

          {error && <Error><p>Campos obligatorios faltantes</p></Error>}

          <input className="form-control" name="Nombre" placeholder="Nombre" onChange={handleChange}/>
          <br/>
          <input className="form-control" name="Apellido" placeholder="Apellido" onChange={handleChange}/>
          <br/>
          <input className="form-control" name="DNI" placeholder="DNI" onChange={handleChange}/>
          <br/>
          <input className="form-control" name="Domicilio" placeholder="Domicilio" onChange={handleChange}/>
          <br/>
          <input className="form-control" name="Telefono" placeholder="Telefono" onChange={handleChange}/>
          <br/>
          <input className="form-control" name="email" placeholder="Email" onChange={handleChange}/>
          <br/>

          <textarea
            className="form-control"
            name="Observaciones"
            placeholder="Observaciones"
            maxLength={2000}
            onChange={handleChange}
          />

        </ModalBody>

        <ModalFooter>
          <button className="btn btn-primary" onClick={NuevoCliente}>Insertar</button>
          <button className="btn btn-danger" onClick={abrirCerrarModalInsertar}>Cancelar</button>
        </ModalFooter>
      </Modal>

      {/* EDITAR */}
      <Modal isOpen={modalEditar}>
        <ModalHeader>Editar Cliente</ModalHeader>
        <ModalBody>

          <input className="form-control" value={clienteSeleccionado.IdCliente || ''} readOnly/>
          <br/>

          <input className="form-control" name="Nombre" value={clienteSeleccionado.Nombre || ''} onChange={handleChange}/>
          <br/>
          <input className="form-control" name="Apellido" value={clienteSeleccionado.Apellido || ''} onChange={handleChange}/>
          <br/>
          <input className="form-control" name="DNI" value={clienteSeleccionado.DNI || ''} onChange={handleChange}/>
          <br/>
          <input className="form-control" name="Domicilio" value={clienteSeleccionado.Domicilio || ''} onChange={handleChange}/>
          <br/>
          <input className="form-control" name="Telefono" value={clienteSeleccionado.Telefono || ''} onChange={handleChange}/>
          <br/>
          <input className="form-control" name="email" value={clienteSeleccionado.email || ''} onChange={handleChange}/>
          <br/>

          <textarea
            className="form-control"
            name="Observaciones"
            value={clienteSeleccionado.Observaciones || ''}
            onChange={handleChange}
            maxLength={2000}
          />

        </ModalBody>

        <ModalFooter>
          <button className="btn btn-primary" onClick={EditarCliente}>Editar</button>
          <button className="btn btn-danger" onClick={abrirCerrarModalEditar}>Cancelar</button>
        </ModalFooter>
      </Modal>

      {/* ELIMINAR */}
      <Modal isOpen={modalEliminar}>
        <ModalBody>
          ¿Eliminar cliente {clienteSeleccionado?.DNI}?
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-danger" onClick={EliminarCliente}>Sí</button>
          <button className="btn btn-secondary" onClick={abrirCerrarModalEliminar}>No</button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default Clientes